import { ApiRequest } from '../misc/api-request'

export abstract class AbstractState {
  requests: {
    [key: string]: ApiRequest
  } = {}
}

export interface RequestStatus {
  fetching: boolean
  error: string | null
  ok: boolean
}
